<template>
    <div id="dicomCutReportDlg" class="modal" tabindex="-1" role="dialog" data-backdrop="static"
        data-bs-backdrop="static" data-bs-keyboard="false">
        <div id="dicomCutReportModal" class="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div id="dicomCutReportContent" class="modal-content wizard-content">
                <div id="dicomCutReportHeader" class="modal-header wizard-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div id="dicomCutReportPano" class="modal-body wizard-body">
                    <div id="cutReportImgCtrl" class="panoramic-ctrl">
                        <img id="cutReportImg" class="cut-panoramic-img" @load="onImageLoad" />
                        <div id="cutRangeLines" @mousemove="onRangeLinesMouseMove($event)"
                            @mouseup="onRangeLinesMouseUp($event)">
                            <div v-for="cutImage in context.cutImages" class="cut-line cut-image-line"
                                v-bind:style="{ left: (cutImage.cutShift * imageWidth / context.cutMax) + 'px' }">
                            </div>
                            <div id="cutStartLine" class="cut-line" @mousedown.left="onStartLineMouseDown($event)"
                                v-bind:style="{ left: (context.cutStart * imageWidth / context.cutMax) + 'px' }"></div>
                            <div id="cutEndLine" class="cut-line" @mousedown.left="onEndLineMouseDown($event)"
                                v-bind:style="{ left: (context.cutEnd * imageWidth / context.cutMax) + 'px' }"></div>
                        </div>
                        <div id="cutReportRuler">
                            <div v-for="(n, i) in context.cutLength" :key="n" class="vertical-line"
                                v-bind:style="{ height: i % 10 == 0 ? '100%' : '50%' }" :title="i">
                                <div v-if="i % 10 == 0 && i > 0" class="line-title">{{ i }}</div>
                            </div>
                        </div>
                        <!-- <div id="cutReportRange">
                           
                        </div> -->
                    </div>
                </div>

                <div id="dicomCutReportButtons" class="modal-footer wizard-footer">
                    <div class="input-group mb-1 mt-1 dentation-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Dentation:</span>
                        </div>
                        <select v-model="context.dentation" class="form-control" @change="dentationChanged()">
                            <option v-for="option in context.dentations" v-bind:value="option">
                                {{ option.text }}
                            </option>
                        </select>
                    </div>

                    <button type="button" class="btn btn-primary" v-on:click="generateCutsClick()">
                        Generate Cuts
                    </button>

                    <button type="button" class="btn btn-primary" v-on:click="generatePdfClick()">
                        Generate Report
                    </button>

                    <button type="button" class="btn btn-primary" v-on:click="savePdfClick()">
                        Save Report
                    </button>

                    <button type="button" class="btn btn-primary" v-on:click="saveSettingsClick()">
                        Save Settings
                    </button>

                    <button type="button" class="btn btn-primary" v-on:click="exitClick()">
                        Exit
                    </button>

                    <!-- <label v-show="context.cutImages.length" class="show-top-ctrl">
                        <span class="check-label">Show Top Controls:</span>
                        <input type="checkbox" class="check-input" v-model="context.showTopControls">
                    </label> -->
                </div>

                <div id="dicomCutReportMain" v-show="context.cutImages && context.cutImages.length">
                    <div class="cut-controls">
                        <div class="row container-group">
                            <div class="input-group mb-1 mt-1 input-group-sm cut-range-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Cut Start:</span>
                                </div>
                                <input v-model="context.cutStart" @change="cutStartChanged()"
                                    class="form-control form-control-sm" type="number" :min="context.cutMin"
                                    :max="context.cutMax" :step="context.cutStep" />
                            </div>
                            <div class="input-group mb-1 mt-1 input-group-sm cut-end-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Cut End:</span>
                                </div>
                                <input v-model="context.cutEnd" @change="cutEndChanged()"
                                    class="form-control form-control-sm" type="number" :min="context.cutMin"
                                    :max="context.cutMax" :step="context.cutStep" />
                            </div>
                        </div>
                        <div class="row container-group">

                            <div class="input-group mb-1 mt-1 input-group-sm">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Slice Interval (mm):</span>
                                </div>
                                <input v-model="context.sliceInterval" @change="sliceIntervalChanged()"
                                    class="form-control form-control-sm" type="number" min="1" max="16" step="1" />
                                <!-- <select v-model="context.sliceInterval" class="form-control form-control-sm"
                                @change="sliceIntervalChanged()">
                                <option v-for="option in context.sliceIntervals" v-bind:value="option">
                                    {{ option }} mm
                                </option>
                            </select> -->
                            </div>

                        </div>

                        <div class="row container-group">
                            <div class="input-group mb-1 mt-1 input-group-sm cut-range-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Images Per Line:</span>
                                </div>
                                <input v-model="context.imagesPerLine" @change="imagesPerLineChanged()"
                                    class="form-control form-control-sm" type="number" min="6" max="8" step="1" />
                            </div>

                            <div class="input-group mb-1 mt-1 input-group-sm lines-range-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Lines each:</span>
                                </div>
                                <select v-model="context.lineFrequency" class="form-control form-control-sm"
                                    @change="lineFrequencyChanged()">
                                    <option v-for="option in context.lineFrequencies" v-bind:value="option">
                                        {{ option.text }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="row container-group">


                            <div class="input-group mb-1 mt-1 input-group-sm keep-nerve-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Keep vertical line:</span>
                                </div>
                                <select v-model="context.nerveLineLogic" class="form-control form-control-sm"
                                    @change="nerveLineLogicChanged()">
                                    <option v-for="option in context.nerveLineLogics" v-bind:value="option">
                                        {{ option.text }}
                                    </option>
                                </select>
                            </div>

                            <label class="cut-range-ctrl">
                                <span class="check-label">Show Lines:</span>
                                <input type="checkbox" class="check-input" v-model="context.showLines"
                                    @change="showLinesChanged()">
                            </label>
                        </div>

                        <div class="row container-group">
                            <div class="input-group mb-1 mt-1 input-group-sm measure-color-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Measure Color:</span>
                                </div>
                                <input class="form-control form-control-sm" type="color"
                                    v-model="context.measureColor" />
                            </div>

                            <div class="input-group mb-1 mt-1 input-group-sm nerve-color-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Nerve Color:</span>
                                </div>
                                <input class="form-control form-control-sm" type="color" v-model="context.nerveColor" />
                            </div>
                        </div>

                        <div class="row container-group">
                            <div class="input-group mb-1 mt-1 input-group-sm nerve-color-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Width Color:</span>
                                </div>
                                <input class="form-control form-control-sm" type="color" v-model="context.widthColor" />
                            </div>

                            <div class="input-group mb-1 mt-1 input-group-sm sharp-image-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Sharp Image Value:</span>
                                </div>
                                <input v-model="context.sharpImageValue" @change="sharpValueChanged()"
                                    class="form-control form-control-sm" type="number" min="0" max="100" step="1" />
                            </div>
                        </div>

                        <!-- <div class="row container-group checkbox-group">
                            <label class="cut-range-ctrl">
                                <span class="check-label">Pano On Each Page:</span>
                                <input type="checkbox" class="check-input" v-model="context.panoOnEachPage">
                            </label>
                            <label class="cut-range-ctrl">
                                <span class="check-label">Pano&3D Side By Side:</span>
                                <input type="checkbox" class="check-input" v-model="context.pano3dSideBySide">
                            </label>
                        </div> -->
                    </div>

                    <div class="cut-images-cont" v-show="context.cutImages && context.cutImages.length">
                        <div class="cut-images-panel">
                            <div class="cut-image-div" v-for="cutImage in context.cutImages"
                                v-bind:style="{ width: cutWidthPercent }">
                                <DicomCutItem :context="context" :cutImage="cutImage" />
                                <!-- <img class="cut-image"
                                :src="cutImage.showLines && context.showLines ? cutImage.overlayImage : cutImage.baseImage"> -->
                                <div v-show="cutImage.showLines && context.showLines" class="cut-image-ruler">
                                    <div v-for="(n, i) in context.imgHeight" :key="n" class="horizontal-line"
                                        v-bind:style="{ width: i % 10 == 0 ? '100%' : '50%' }" :title="i">
                                        <div v-if="i % 10 == 0 && i > 0" class="horizontal-line-title">{{
                            context.imgHeight
                            - i }}</div>
                                    </div>
                                </div>

                                <div class="cut-image-title cut-title-top1">
                                    L
                                </div>
                                <div class="cut-image-title">
                                    {{ cutImage.cutShift }}
                                </div>
                                <div class="cut-image-title cut-title-top2">
                                    B
                                </div>
                                <div v-show="cutImage.showLines && context.showLines"
                                    class="cut-image-text cut-text-top cut-label"
                                    v-bind:style="{ top: cutImage.isUpper ? '85%' : '7%', color: context.widthColor }">
                                    {{ cutImage.topDistanceText }}
                                </div>
                                <div v-show="cutImage.showLines && context.showLines"
                                    class="cut-image-text cut-text-nerve cut-label"
                                    v-bind:style="{ top: cutImage.isUpper ? '7%' : '85%', color: cutImage.isUpper ? context.measureColor : context.nerveColor }">
                                    {{ cutImage.nerveDistanceText }}
                                </div>

                                <img :title="cutImage.showLines ? 'Hide Lines' : 'Show Lines'"
                                    class="cut-tool cut-image-show-lines"
                                    v-on:click="showLinesOnImageClick(cutImage, $event)"
                                    :src="cutImage.showLines ? 'images/visible_on_white.png' : 'images/visible_off_white.png'">
                                </img>
                                <img title="Edit Lines" class="cut-tool cut-image-edit-lines"
                                    v-on:click="showEditPopupClick(cutImage)" src="images/annotation_white.png">
                                </img>

                            </div>
                        </div>
                    </div>
                </div>

                <div id="cutReportEditPopup" class="cut-edit-popup" v-on:click="closeContextMenu()">
                    <span v-if="selectedCutImage" class="cut-span shift-span">{{ selectedCutImage.cutShift }}</span>
                    <span v-if="selectedCutImage" class="cut-span top-span">{{ selectedCutImage.topDistanceTextP
                        }}</span>
                    <span v-if="selectedCutImage" class="cut-span nerve-span"
                        v-bind:style="{ color: selectedCutImage.isUpper ? 'yellow' : 'red' }">{{
                            selectedCutImage.nerveDistanceTextP
                        }}</span>

                    <span class="cut-span close-span" aria-hidden="true" v-on:click="closeEditPopupClick">&times;</span>

                    <img v-if="selectedCutImage" class="cut-selected-image" :src="selectedCutImage.baseImage">

                    <div id="cutReportEditKonva" @contextmenu.prevent="openEditContextMenu"></div>
                    <!-- <canvas id="cutReportEditCanvas"> </canvas> -->

                    <button type="button" class="btn btn-primary btn-sm save-popup-btn"
                        v-on:click="saveEditPopupClick(selectedCutImage)">
                        Save
                    </button>

                    <button type="button" class="btn btn-primary btn-sm cancel-popup-btn"
                        v-on:click="closeEditPopupClick()">
                        Close
                    </button>
                </div>

                <div id="cutReportImageMenu" class="tooth-menu">
                    <button id="cutReportImageAddLineBtn" class="tooth-menu-btn"
                        v-on:click="addVerticalLineClick(selectedCutImage, $event)">Add
                        Vertical Line</button>
                </div>

                <div id="cutReportPdfOptions" class="container-fluid">
                    <span class="close-pdf-span" aria-hidden="true" v-on:click="closePdfClick">&times;</span>

                    <div class="row single-row">
                        <label for="dreportName" class="form-label">Report Name:</label>
                        <input id="dreportName" v-model="context.reportData.reportName" class="form-control" type="text"
                            maxlength="50" pattern="[a-zA-Z0-9\s]+" v-on:keydown.stop>
                        </input>
                    </div>

                    <div class="row settings-row">
                        <div class="col-12 data-div">
                            <hr class="data-split-line" />
                            <label class="form-label data-label" for="null">Settings:</label>
                        </div>
                        <!-- <label class="cut-range-ctrl">
                            <span class="check-label">Pano On Each Page:</span>
                            <input type="checkbox" class="check-input" v-model="context.panoOnEachPage">
                        </label>
                        <label class="cut-range-ctrl">
                            <span class="check-label">Pano&3D Side By Side:</span>
                            <input type="checkbox" class="check-input" v-model="context.pano3dSideBySide">
                        </label> -->
                        <div class="col-6">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="PanoOnEachPageCb"
                                    v-model="context.panoOnEachPage">
                                <label class="form-check-label" for="PanoOnEachPageCb">Pano On Each Page</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="Pano3DSideBySideCb"
                                    v-model="context.pano3dSideBySide">
                                <label class="form-check-label" for="Pano3DSideBySideCb">Pano&3D Side By Side</label>
                            </div>
                        </div>

                        <div class="col-7 input-group background-color-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Background Color:</span>
                            </div>
                            <input class="form-control" type="color" v-model="context.backgroundColor" />
                        </div>


                    </div>

                    <div class="row data-row">
                        <div class="col-12 data-div">
                            <hr class="data-split-line" />
                            <label class="form-label data-label" for="null">Data To Include:</label>
                        </div>

                        <div class="col-6">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="dcompanyLogoCb"
                                    v-model="context.reportData.isCompanyLogo">
                                <label class="form-check-label" for="dcompanyLogoCb">Company Logo</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="dpatientInfoCb"
                                    v-model="context.reportData.isPatientInfo">
                                <label class="form-check-label" for="dpatientInfoCb">Patient Info</label>
                            </div>
                        </div>
                    </div>

                    <div class="row report-row">
                        <div class="col-6">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="dcaseLinkCb"
                                    v-model="context.reportData.isCaseLink">
                                <label class="form-check-label" for="dcaseLinkCb">Case Link</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="dqrCodeCb"
                                    v-model="context.reportData.isQrCode">
                                <label class="form-check-label" for="dqrCodeCb">QR Code</label>
                            </div>
                        </div>

                        <div v-show="linkIncluded" class="col-12">
                            <hr class="report-split-line" />
                        </div>
                    </div>

                    <div v-show="linkIncluded" class="row single-row">
                        <label for="dshareExpiration" class="form-label">Link expiration:</label>
                        <select id="dshareExpiration" v-model="context.reportData.linkExpiration" class="form-control">
                            <option v-for="option in expirations" v-bind:value="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                    </div>

                    <div v-show="linkIncluded" class="row report-row">
                        <div class="col-6 col-check">
                            <div class="form-check left-form-check">
                                <input type="checkbox" class="form-check-input" id="dreadonlyCheck"
                                    v-model="context.reportData.isLinkReadOnly">
                                <label class="form-check-label" for="dreadonlyCheck">Read-Only</label>
                            </div>
                        </div>
                        <div class="col-6 col-check">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="dresetCaseCheck"
                                    v-model="context.reportData.isLinkResetCase">
                                <label class="form-check-label" for="dresetCaseCheck">Reset Case</label>
                            </div>
                        </div>
                    </div>

                    <div v-show="linkIncluded" class="row report-row">
                        <div class="col-6 col-check">
                            <div class="form-check left-form-check">
                                <input type="checkbox" class="form-check-input" id="dallowDownloadsCheck"
                                    v-model="context.reportData.isLinkAllowDownloads">
                                <label class="form-check-label" for="dallowDownloadsCheck">Allow
                                    Downloads</label>
                            </div>
                        </div>
                        <div class="col-6 col-check">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="danonymizedCheck"
                                    v-model="context.reportData.isLinkAnonymized">
                                <label class="form-check-label" for="danonymizedCheck">Anonymized</label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <button id="btnSavePdfWithOptions" class="btn btn-primary" aria-label="PDF"
                                v-on:click="savePdfWithOptionsClick()">OK</button>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>

import DicomCutItem from "./DicomCutItem.vue";
import {
    fillCutImages,
    saveCutsReport,
    drawLinesOnKonva,
    addVerticalLineToSelectedImage,
    saveKonvaChanges,
    saveSettings,
    showReportOptions,
    showEditPopup,
    globalKonvaStage,
    globalKonvaLayer
} from "./DicomCutReports";
import Konva from "konva";

export default {
    name: "DicomCutReportDlg",
    components: {
        DicomCutItem,
    },
    props: ["context"],
    data() {
        return {
            imageWidth: 900,
            temp: 0,
            draggedLine: null,
            dragLineX: 0,
            dragClientX: 0,
            selectedCutImage: null,
            pdfFunctionI: 0,
            expirations: [
                { text: "Never expire", value: 0 },
                { text: "Expire after 1 day", value: 1 },
                { text: "Expire after 10 days", value: 10 },
                { text: "Expire after 30 days", value: 30 },
                { text: "Expire after 100 days", value: 100 },
            ],
        }
    },
    computed: {
        isTopVisible() {
            return true;
            // this.context.showTopControls || !this.context.cutImages.length;
        }
    },
    methods: {
        saveSettingsClick: function () {
            saveSettings();
        },
        onRangeLinesMouseUp: function (event) {
            this.dragEnd();
        },
        onRangeLinesMouseMove: function (event) {
            if (this.draggedLine) {
                let xdif = event.clientX - this.dragClientX;
                this.dragLineX += xdif;
                this.dragClientX = event.clientX;
                this.draggedLine.style.left = this.dragLineX + "px";
                if (this.draggedLine.isStart) {
                    this.context.cutStart = Math.round((this.dragLineX / this.imageWidth) * this.context.cutMax);
                    // console.log("onRangeLinesMouseMove cutStart", cutStart);
                } else {
                    this.context.cutEnd = Math.round((this.dragLineX / this.imageWidth) * this.context.cutMax);
                    // console.log("onRangeLinesMouseMove cutEnd", cutEnd);
                }
            }
        },
        onStartLineMouseDown: function (event) {
            this.draggedLine = event.srcElement;
            this.dragClientX = event.clientX;
            this.dragLineX = +this.draggedLine.style.left.replace("px", "");
            // console.log("onStartLineMouseDown", this.dragLineX);
            document.getElementById("cutRangeLines").style.cursor = "ew-resize";
            this.draggedLine.isStart = true;
        },
        onEndLineMouseDown: function (event) {
            this.draggedLine = event.srcElement;
            this.dragClientX = event.clientX;
            this.dragLineX = +this.draggedLine.style.left.replace("px", "");
            document.getElementById("cutRangeLines").style.cursor = "ew-resize";
            this.draggedLine.isStart = false;
        },
        showEditPopupClick: function (cutImage, event) {
            console.log("showEditPopupClick 1", cutImage);
            this.selectedCutImage = cutImage;
            showEditPopup(cutImage);
        },
        saveEditPopupClick: function (cutImage, event) {
            if (!cutImage)
                cutImage = this.selectedCutImage;
            saveKonvaChanges(globalKonvaStage, cutImage, true);
            document.getElementById("cutReportEditPopup").style.display = 'none';
        },
        closeEditPopupClick: function () {
            document.getElementById("cutReportEditPopup").style.display = 'none';
        },
        openEditContextMenu: function (event) {
            let cutImage = this.selectedCutImage;
            console.log("openEditContextMenu", event.offsetX, event.offsetY, cutImage);
            let lines = cutImage.imagesObj.popupLines;
            let nervLine = lines.find((x) => x.isNerve);
            if (nervLine)
                return;

            let cutImageMenu = document.getElementById("cutReportImageMenu");
            document.getElementById("cutReportEditKonva").appendChild(cutImageMenu);
            cutImageMenu.style.display = "initial";
            cutImageMenu.style.left = event.offsetX + 1 + "px";
            cutImageMenu.style.top = event.offsetY + 1 + "px";

            this.context.selectedImage = this.selectedCutImage;
            this.context.selectedStage = globalKonvaStage;
            this.context.selectedLayer = globalKonvaLayer;
            this.context.clickPoint = { x: event.offsetX, y: event.offsetY };

            // const stageWidth = globalKonvaStage.width();
            // const stageHeight = globalKonvaStage.height();
            // console.log("openEditContextMenu", event.offsetX, event.offsetY, stageWidth, stageHeight);
        },
        closeContextMenu: function (event) {
            let cutImageMenu = document.getElementById("cutReportImageMenu");
            cutImageMenu.style.display = "none";
        },
        addVerticalLineClick: function (cutImage, event) {
            addVerticalLineToSelectedImage();
        },
        showLinesOnImageClick: function (cutImage, event) {
            console.log("showLinesOnImageClick", cutImage);
            cutImage.showLines = !cutImage.showLines;
            // const elements = event.srcElement.parentElement.querySelectorAll('.cut-label');
            // elements.forEach(element => {
            //     element.style.display = cutImage.showLines && this.context.showLines ? 'block' : 'none';
            // });
        },
        generateCutsClick: async function () {
            console.log("generateCutsClick");
            await fillCutImages();

            this.adjustImageWidth();
        },
        generatePdfClick: async function () {
            console.log("generatePdfClick");
            this.pdfFunctionI = 1;
            showReportOptions();
        },
        savePdfClick: async function () {
            console.log("savePdfClick");
            this.pdfFunctionI = 2;
            showReportOptions();
        },
        savePdfWithOptionsClick: async function () {
            console.log("savePdfWithOptionsClick");
            document.getElementById("cutReportPdfOptions").style.display = 'none';
            await fillCutImages();
            saveCutsReport(this.pdfFunctionI);
        },
        closePdfClick: function () {
            console.log("closePdfClick");
            document.getElementById("cutReportPdfOptions").style.display = 'none';
        },
        exitClick: function () {
            console.log("exitClick");
            $("#dicomCutReportDlg").modal("hide");
        },
        cutStartChanged: function () {
            console.log("cutStartChanged", this.context.cutStart);
        },
        cutEndChanged: function () {
            console.log("cutEndChanged", this.context.cutEnd);
        },
        sharpValueChanged: function () {
            console.log("sharpValueChanged", this.context.sharpImageValue);
            fillCutImages(true);
        },
        sliceIntervalChanged: function () {
            console.log("sliceIntervalChanged", this.context.sliceInterval);
        },
        dentationChanged: function () {
            console.log("dentationChanged", this.context.dentation);
            let img = document.getElementById("cutReportImg");
            img.src = this.context.dentation.imageUrl;
            // let isUpper = this.context.dentation.isUpper;
            // img.src = isUpper ? img.src.replace("mandible", "maxilla") : img.src.replace("maxilla", "mandible");
            if (this.context.cutImages.length > 0)
                fillCutImages();
        },
        lineFrequencyChanged: function () {
            console.log("lineFrequencyChanged", this.context.lineFrequency);
            fillCutImages();
        },
        dragEnd: function () {
            if (this.draggedLine) {
                this.draggedLine = null;
                document.getElementById("cutRangeLines").style.cursor = 'default';
            }
        },
        onImageLoad: function (event) {
            let img = event.target;
            console.log("onImageLoad", img);
            this.context.panoramicWidth = img.width;
            this.context.panoramicHeight = img.height;
        },
        imagesPerLineChanged: function () {

        },
        showLinesChanged: function () {
            console.log("showLinesChanged", this.context.showLines);
            // this.context.showLines = !this.context.showLines;
        },
        nerveLineLogicChanged: function () {
            console.log("nerveLineLogicChanged", this.context.nerveLineLogic);
        },
        adjustImageWidth: function () {
            const element = document.getElementById("dicomCutReportModal");
            //document.querySelector('.my-element');
            const rect = element.getBoundingClientRect();
            let actualWidth = rect.width;
            if (!actualWidth) {
                const documentWidth = Math.max(
                    document.body.scrollWidth,
                    document.documentElement.scrollWidth,
                    document.body.offsetWidth,
                    document.documentElement.offsetWidth,
                    document.body.clientWidth,
                    document.documentElement.clientWidth
                );
                actualWidth = +documentWidth * 0.7; // .replace("px", "") 
            }
            console.log("actualWidth", actualWidth);
            this.context.panoWidth = this.imageWidth = actualWidth - 24;

            const header = document.getElementById("dicomCutReportHeader");
            const pano = document.getElementById("dicomCutReportPano");
            const buttons = document.getElementById("dicomCutReportButtons");

            let restHeight = header.getBoundingClientRect().height + pano.getBoundingClientRect().height + buttons.getBoundingClientRect().height;
            console.log("restHeight", restHeight);
            //header.offsetHeight + pano.offsetHeight + buttons.offsetHeight;
            if (restHeight > 0) {
                const main = document.getElementById("dicomCutReportMain");
                main.style.maxHeight = `calc(97vh - ${restHeight}px)`;
            }
        },
    },
    computed: {
        proportion: function () {
            return 100 / (this.context.ranges.length - 1);
        },
        bigCutMax: function () {
            return Math.floor(this.context.cutMax / 10);
        },
        cutWidthPercent: function () {
            /* 8 = 12.25, 7 = 14.05, 6 = 16.42, */
            let retval = 12.28;
            if (this.context.imagesPerLine <= 6) {
                retval = 16.42;
            } else if (this.context.imagesPerLine == 7) {
                retval = 14.06;
            }
            return `${retval}%`;
        },
        linkIncluded() {
            return this.context.reportData.isCaseLink || this.context.reportData.isQrCode;
        },
    },
    mounted() {
        document.addEventListener('mouseup', () => {
            this.dragEnd();
        });

        document.addEventListener('mouseleave', () => {
            this.dragEnd();
        });

        this.adjustImageWidth();
        window.addEventListener('resize', () => {
            this.adjustImageWidth();
        });
    }
};

</script>

<style scoped>
@import "@/css/wizard.css";

.wizard-footer {
    margin-top: 12px;
}

/* .modal-dialog {
    max-height: 100%;
} */

.modal-content {
    max-height: 99vh;
}

#dicomCutReportModal {
    /* max-width: 924px; */
    min-width: 864px;
    width: 70%;
    max-width: 80%;
}

.modal-header {
    height: 20px;
    box-sizing: border-box;
}

.modal-header .close {
    padding-top: 0.3rem;
    padding-right: 0.5rem;
}

.modal-body {
    box-sizing: border-box;
    padding-top: 0;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 12px;
}


#dicomCutReportPano {
    padding-bottom: 0px;
    /* display: flex; */
}

#dicomCutReportMain {
    display: flex;
    max-height: calc(99vh - 510px);
}

.cut-controls {
    flex-grow: 0;
}

.cut-images-cont {
    flex-grow: 1;
    /* max-height: 90%; */
    /* max-height: 50vh; */
    background: gainsboro;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: thin;
}

.cut-images-panel {
    margin-left: 3px;
    display: flex;
    flex-wrap: wrap;
    width: calc(100% - 4px);
    gap: 1px;
}

.cut-range-ctrl {
    margin-top: 7px;
    margin-left: 15px;
    margin-right: 25px;
    margin-bottom: 0;
    /* padding-bottom: 0; */
    /* height: 30px; */
    text-align: right;
    display: inline;
    white-space: nowrap;
}

.show-top-ctrl {
    margin-top: 2px;
    margin-left: 10px;
    margin-bottom: 0;
    text-align: right;
    display: inline;
    white-space: nowrap;
}

.check-label {
    margin-right: 0.5rem;
    vertical-align: middle;
}

.check-input {
    vertical-align: middle;
}

.save-popup-btn {
    position: absolute;
    bottom: 5px;
    left: 60px;
    width: 80px;
}

.cancel-popup-btn {
    position: absolute;
    bottom: 5px;
    left: 160px;
    width: 80px;
}

.cut-edit-popup {
    position: absolute;
    width: 302px;
    height: 624px;
    /* 664px; */
    left: calc(50% - 151px);
    top: calc(50% - 322px);
    /* 10px; */
    display: none;
    z-index: 1000;
    text-shadow: 1px 1px 2px black;
    border: 1px solid #007bff;
    background: black;
}

.cut-selected-image {
    width: 300px;
    height: 600px;
    margin-top: 22px;
    margin-bottom: 20px;
    position: absolute;
    /* image-rendering: pixelated; */
}

#cutReportEditKonva {
    width: 300px;
    height: 600px;
    margin-top: 22px;
    margin-bottom: 20px;
    position: absolute;
    /* background: red; */
    /* opacity: 0.5; */
}

#cutReportEditKonva .konvajs-content {
    opacity: 0.5;
}

#cutReportEditKonva div:first-child {
    opacity: 0.5;
}

#cutReportImageMenu {
    opacity: 1;
}

.cut-span {
    position: absolute;
    text-shadow: 1px 1px 2px black;
    z-index: 1;
    left: 2px;
}

.shift-span {
    color: yellow;
}

.top-span {
    color: aqua;
    left: 35px;
}

.nerve-span {
    color: red;
    left: 117px;
}

.close-span {
    color: white;
    position: absolute;
    top: -8px;
    left: auto;
    right: 2px;
    font-size: 25px;
    cursor: pointer;
}

.cut-tool {
    cursor: pointer;
}

.cut-image-show-lines {
    position: absolute;
    left: 4px;
    bottom: 3px;
    height: 23px;
    width: 23px;
}

.cut-image-edit-lines {
    position: absolute;
    right: 7px;
    bottom: 3px;
    height: 23px;
    width: 23px;
}


/* 8 = 12.25, 7 = 14.05, 6 = 16.42, */
.cut-image-div {
    width: 16.42%;
    aspect-ratio: 1 / 2;
    margin: 0px;
    position: relative;
}

.cut-image-title {
    font-family: Helvetica, sans-serif;
    position: absolute;
    color: yellow;
    left: calc(50% - 10px);
    top: 0;
    z-index: 100;
    pointer-events: none;
}

.cut-title-top1 {
    left: 5px;
}

.cut-title-top2 {
    left: auto;
    right: 6px;
}

.cut-image-text {
    font-family: Helvetica, sans-serif;
    position: absolute;
    right: 3px;
    top: 0;
    z-index: 100;
    font-size: small;
    text-shadow: 1px 1px 2px black;
    pointer-events: none;
    /* -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: black;
     text-stroke-width: 1px;
    text-stroke-color: black; */
}

.cut-text-top {
    left: 3px;
    top: 27%;
    color: aqua;
}

.cut-text-nerve {
    left: 3px;
    top: 70%;
    color: red;
}

.cut-image {
    width: 100%;
    height: 100%;
    /* image-rendering: pixelated; */
}

.line-title {
    color: yellow;
    margin-top: -20px;
    margin-left: -15px;
    font-size: small;
    width: 30px;
    text-align: center;
    text-shadow: 1px 1px 2px black;
}

.line-container {
    position: absolute;
    bottom: 0;
    width: 100%;

}

.cut-image-ruler {
    pointer-events: none;
    top: 0;
    position: absolute;
    right: 0px;
    text-align: center;
    white-space: nowrap;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 10px;
    align-items: flex-end;
    opacity: 0.6;
}

.horizontal-line {
    margin-top: -0.5px;
    border-top: 1px solid white;
    height: 0;
    width: 100%;
}

.horizontal-line-title {
    color: white;
    margin-top: -8px;
    margin-left: -22px;
    font-size: x-small;
    width: 30px;
    text-align: center;
    text-shadow: 1px 1px 2px black;
}

.vertical-line {
    border-left: 1px solid aqua;
    height: 100%;
    width: 0;
}

#cutReportRuler {
    position: absolute;
    bottom: 0;
    text-align: center;
    white-space: nowrap;
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 14px;
    align-items: flex-end;
    /* background: greenyellow; */
}

#cutRangeLines {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    /* background: greenyellow; */
}

.cut-line {
    position: absolute;
    top: 0;
    border-left: 1px solid yellow;
    height: 100%;
    width: 2px;
    margin-left: -0px;
    cursor: ew-resize;
}

.cut-image-line {
    border-left: 1px dashed yellow;
    opacity: 0.5;
}

.panoramic-ctrl {
    position: relative;
    box-sizing: border-box;
}

#cutReportImg {
    width: 100%;
    height: auto;
}

.btn {
    border-radius: 0;
}

.cut-report-save-btn {
    width: 25px;
    height: 25px;
    cursor: pointer;
    margin-top: 7px;
}

.container-group {
    /* border: 2px solid #d7dee5;
    border-radius: 0.25rem; */
    margin: 10px 0 0 15px;
    /* padding: 10px 0 4px 0; */
    justify-content: stretch;
}

.checkbox-group {
    margin-top: 3px;
    /* margin-bottom: 2px; */
    margin-left: 3px;
}

.input-group {
    width: 47%;
    margin-right: 10px;
}

.dentation-group {
    margin-top: 2px;
    width: auto;
    margin-right: 5px;
}

.cut-range-group {
    width: 47%;
}

.sharp-image-group {
    width: 47%;
}

.cut-end-group {
    width: 47%;
}

.lines-range-group {
    width: 47%;
}

.keep-nerve-group {
    width: 63%;
}

.measure-color-group {
    width: 47%;
}

.background-color-group {
    width: 200px;
    margin-top: 15px;
    margin-left: -3px;
}

.nerve-color-group {
    width: 47%;
}
</style>

<!-- report styles -->
<style scoped>
#cutReportPdfOptions {
    position: absolute;
    width: 502px;
    /* min-height: 402px; */
    left: calc(50% - 201px);
    top: calc(50% - 301px);
    display: none;
    z-index: 1000;
    border: 1px solid #007bff;
    background: white;
}

.close-pdf-span {
    color: black;
    position: absolute;
    top: -8px;
    left: auto;
    right: 2px;
    font-size: 25px;
    cursor: pointer;
}


.report-split-line {
    margin-left: -15px;
    margin-top: 15px;
    margin-bottom: 0;
    border-top: 1px solid grey;
}

.report-row {
    margin-top: 20px;
    margin-left: 5px;
}

.settings-row {
    margin-top: 0;
    margin-left: 5px;
}

.data-row {
    margin-top: 0;
    margin-left: 5px;
}

.data-div {
    margin-top: 0;
    margin-left: 0;
}

.data-label {
    margin-top: 5px;
    margin-bottom: 10px;
}

.data-split-line {
    margin-left: -15px;
    margin-top: 15px;
    margin-bottom: 10px;
    border-top: 1px solid grey;
}

.single-row {
    margin-top: 15px;
    margin-left: 15px;
    margin-right: 5px;
}

#btnSavePdfWithOptions {
    width: 100%;
    border-radius: 0px;
    height: 40px;
    background-color: #0069d9;
    margin-top: 20px;
    margin-bottom: 20px;
}
</style>